import React, { useState, useEffect, useMemo } from "react";
import "../../assets/css/data-table.css";
import Swal from "sweetalert2";
import {
  Card,
  CardBody,
  Button,
  Input,
  FormGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import DataTable from "react-data-table-component";
import DataTableSettings from "../../utils/DataTableSettings";
import { AttributeForm, BreadCrumb } from "../../config/Components";
import { API_ATTRIBUTES } from "../../config/Api";

const AttributeList = (props) => {
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [attributeId, setAttributeId] = useState(0);
  const toggle = () => {
    setModal(!modal);
    setAttributeId(0);
  };
  const [attributes, setAttributes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const searchParam = [
    "attribute_name",
    "price",
    "code",
    "description",
    "template_code",
  ];

  useEffect(() => {
    fetchAttributes();
  }, []);

  const fetchAttributes = async () => {
    props.callRequest("GET", API_ATTRIBUTES, true).then((res) => {
      setAttributes(res.data);
      setLoading(false);
    });
  };

  const columns = [
    {
      name: "Attribute Name",
      selector: "attribute_name",
      sortable: true,
    },
    {
      name: "Price",
      selector: "price",
      sortable: true,
    },
    {
      name: "Code",
      selector: "code",
      sortable: true,
    },
    {
      name: "Description",
      selector: "description",
      sortable: true,
    },
    {
      name: "Template Code",
      selector: "template_code",
      sortable: true,
      // cell: (row) => (
      //   <div style={{ "max-width": "100px" }}>{row.template_code}</div>
      // ),
    },
    {
      name: "Actions",
      selector: "attribute_id",
      sortable: false,
      cell: (row) => (
        <UncontrolledDropdown>
          <DropdownToggle>
            <i className="fas fa-ellipsis-v"></i>
          </DropdownToggle>
          <DropdownMenu positionFixed={true}>
            <DropdownItem onClick={() => editAttribute(row.attribute_id)}>
              Edit
            </DropdownItem>
            <DropdownItem onClick={() => onDelete(row.attribute_id)}>
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ];

  const editAttribute = (attribute_id) => {
    toggle();
    setAttributeId(attribute_id);
  };

  const onDelete = (attribute_id) => {
    Swal.fire({
      icon: "question",
      title: "Do you want to delete?",
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        props
          .callRequest("DELETE", API_ATTRIBUTES + attribute_id, true)
          .then((res) => {
            // if (res.statusText === "No Content") {
            if (res.status == 204) {
              Swal.fire("Deleted!", "", "success");
              fetchAttributes();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <FormGroup>
        <Input
          id="search"
          type="text"
          placeholder="Search"
          aria-label="Search Input"
          value={filterText}
          autoComplete="off"
          onChange={(e) => setFilterText(e.target.value)}
        />
      </FormGroup>
    );
  }, [filterText]);

  const Export = ({ onExport }) => (
    <div className="right-button-block">
      <Button onClick={toggle}>
        <i className="ni ni-fat-add"></i> Add Attribute
      </Button>
      {/* <UncontrolledDropdown>
        <DropdownToggle caret>
          <i className="bi-filter"></i> Filter
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>Filter Name 1</DropdownItem>
          <DropdownItem>Filter Name 2</DropdownItem>
          <DropdownItem>Filter Name 3</DropdownItem>
          <DropdownItem>Filter Name 4</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <Button><i className="bi-pencil-square"></i> Edit Columns</Button> */}
      {/* <Button
        disabled={attributes.length > 0 ? false : true}
        onClick={(e) => onExport(e.target.value)}
      >
        <i className="ni ni-ungroup"></i> Export
      </Button> */}
    </div>
  );

  const export_column = [
    "attribute_name",
    "price",
    "code",
    "description",
    "template_code",
  ];

  const actionsExport = useMemo(
    () => (
      <Export
        onExport={() =>
          DataTableSettings.downloadCSV(
            attributes,
            export_column,
            props.generateUniqueId()
          )
        }
      />
    ),
    [attributes]
  );

  return (
    <>
      <main role="main" className="pt-3 px-4">
        <div className="main-heading-block">
          <BreadCrumb links={["Attributes", "Attribute List"]} />
          <h1 className="header-title">
            <span className="header-icon">
              <i className="ni ni-bag-17"></i>
            </span>
            Attribute List
          </h1>
        </div>

        <div className="listingtable-main-block">
          <Card>
            <CardBody>
              <Modal isOpen={modal} toggle={toggle} className={className}>
                {attributeId === 0 ? (
                  <ModalHeader toggle={toggle}>Add Attribute</ModalHeader>
                ) : (
                  <ModalHeader toggle={toggle}>Edit Attribute</ModalHeader>
                )}
                <ModalBody>
                  <AttributeForm
                    {...props}
                    modalToggle={toggle}
                    fetchAttributes={fetchAttributes}
                    attributeId={attributeId}
                  />
                </ModalBody>
              </Modal>

              <div className="list-filtered-table-block attribute-table-setting">
                {loading === true ? <h3>Loading...</h3> : null}
                {loading === false ? (
                  <DataTable
                    columns={columns}
                    data={DataTableSettings.filterItems(
                      attributes,
                      searchParam,
                      filterText
                    )}
                    pagination
                    paginationPerPage={DataTableSettings.paginationPerPage}
                    paginationRowsPerPageOptions={
                      DataTableSettings.paginationRowsPerPageOptions
                    }
                    actions={actionsExport}
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    persistTableHead
                  />
                ) : null}
              </div>
            </CardBody>
          </Card>
        </div>
      </main>
    </>
  );
};

export default AttributeList;
